import { Badge } from '@components/ui';
import classNames from 'classnames';
import { rgba } from 'polished';
import React from 'react';
import { matchPath, useLocation } from 'react-router';
import { LinkProps } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { DestinationLinkSC } from './destination-link.styled';

interface DestinationLinkProps extends Omit<LinkProps, 'children'> {
  Icon: (p: React.SVGProps<SVGSVGElement>) => JSX.Element;
  to: string;
  exact?: boolean;
  strict?: boolean;
  children: React.ReactNode | ((active: boolean) => JSX.Element);
  badge?: string | number;
}

const DestinationLink = (
  { children, to, exact, strict, Icon, className, badge, ...rest }: DestinationLinkProps,
  ref?: React.Ref<HTMLAnchorElement>,
) => {
  const location = useLocation();
  const theme = useTheme();

  const isMatch = !!matchPath(location.pathname, {
    path: to,
    exact,
    strict,
  });

  return (
    <DestinationLinkSC
      to={to}
      {...rest}
      ref={ref}
      className={classNames(className, { active: isMatch })}
    >
      <div className="icon-wrapper">
        <Badge
          maxCount={99}
          content={badge}
          positionHorizontal="right"
          positionVertical="top"
          badgeStyle={{ top: 4, right: 2 }}
        >
          <Icon
            width={20}
            height={20}
            color={isMatch ? theme.color.tint.primaryDark : rgba(theme.color.tint.primaryDark, 0.6)}
          />
        </Badge>
      </div>
      <div className="content">{typeof children === 'function' ? children(isMatch) : children}</div>
    </DestinationLinkSC>
  );
};

export default React.forwardRef(DestinationLink);
